import { Injectable } from '@angular/core';
import { ApiConService } from './api-con.service';
import { IAvisosNovidades } from './Util';
import { JsonReturn } from './interface/generic-interface';

@Injectable({
  providedIn: 'root'
})
export class PainelMensagensService {

  dcPainelMensagens = 'DCPainelMensagens';
  constructor(private conService: ApiConService) { }

  async dados(){
    let avisosNovidades: IAvisosNovidades[] = []
    const response: JsonReturn = await this.conService.patch(`${this.dcPainelMensagens}`);
    
    let pagina = 1;
    response.response.forEach((element) => {     
      element.Pagina = pagina;
      pagina++;
      avisosNovidades.push(element);
    });

    return avisosNovidades;
  }

  
}
